import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
    CreateCollibraConnectionRequest,
    CreateConnectionResponse,
    CreateDataLakeConnectionRequest,
    RefreshSecretRequest,
    TestConnectionResponse,
    TestDataLakeConnectionRequest,
} from './models/create-collibra-connection-request.model';
import { GetConnectionResponse } from './models/get-connection-response.model';

@Injectable({
    providedIn: 'root',
})
export class ConnectionAutomationService {
    public constructor(private readonly httpClient: HttpClient) {}

    public createCollibraConnection(
        createCollibraConnectionRequest: CreateCollibraConnectionRequest,
    ): Observable<CreateConnectionResponse> {
        return this.httpClient.post<CreateConnectionResponse>('connections', createCollibraConnectionRequest);
    }

    public createDataLakeConnection(
        request: CreateDataLakeConnectionRequest,
    ): Observable<HttpResponse<CreateConnectionResponse>> {
        return this.httpClient.post<CreateConnectionResponse>('connections/datalake', request, { observe: 'response' });
    }

    public testCollibraConnection(request: TestDataLakeConnectionRequest): Observable<TestConnectionResponse> {
        return this.httpClient.post<TestConnectionResponse>('connections/datalake/validation', request);
    }

    public listConnections(): Observable<GetConnectionResponse[]> {
        return this.httpClient.get<GetConnectionResponse[]>('connections');
    }

    public getConnection(connectionId: string): Observable<GetConnectionResponse> {
        return this.httpClient.get<GetConnectionResponse>(`connections/${connectionId}`);
    }

    public refreshSecret(businessDomainId: string, refreshSecretRequest: RefreshSecretRequest): Observable<unknown> {
        return this.httpClient.post<unknown>(
            `business-domains/${businessDomainId}/service-principal/secret`,
            refreshSecretRequest,
        );
    }
}
